import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SocketIoService } from '../socket-io.service';
import { StreamDeviceReadyEventDto } from './dtos/stream-device-ready.event.dto';
import { StreamRoomClosedEventDto } from './dtos/stream-room-closed.event.dto';

@Injectable({ providedIn: 'root' })
export class DeviceStreamEventsService {
  roomClosed$: Observable<StreamRoomClosedEventDto>;

  deviceReady$: Observable<StreamDeviceReadyEventDto>;

  constructor(socketIo: SocketIoService) {
    this.roomClosed$ = socketIo.observeEvent<StreamRoomClosedEventDto>('stream:closed');
    this.deviceReady$ = socketIo.observeEvent<StreamDeviceReadyEventDto>('stream:device-ready');
  }
}
